var _circle, _path, _path2, _circle2, _circle3, _circle4, _path3, _path4, _line, _line2, _line3, _line4, _circle5, _circle6, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404NotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 156,
    viewBox: "0 0 200 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 76,
    r: 70,
    stroke: "#E2E6EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "0.1 9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 96 C 40 84, 60 118, 88 112",
    stroke: "#EAEDF0",
    strokeWidth: 1.5,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 26 C 142 18, 166 34, 184 26",
    stroke: "#EAEDF0",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 169,
    cy: 52,
    r: 2.5,
    fill: "#92A4A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 42,
    r: 2.5,
    fill: "#9EB9D6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 112,
    r: 2,
    fill: "#9EB9D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36 h44 l16 16 v66 a5 5 0 0 1 -5 5 h-55 a5 5 0 0 1 -5 -5 v-77 a5 5 0 0 1 5 -5 z",
    fill: "#FFFFFF",
    stroke: "#314861",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114 36 v16 h16",
    stroke: "#314861",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 66,
    x2: 118,
    y2: 66,
    stroke: "#E2E6EC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 78,
    x2: 122,
    y2: 78,
    stroke: "#E2E6EC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 90,
    x2: 110,
    y2: 90,
    stroke: "#E2E6EC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 102,
    x2: 100,
    y2: 102,
    stroke: "#E2E6EC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 115,
    r: 20,
    fill: "#4D5454"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 111,
    r: 7,
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    fill: "none"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: 116.5,
    x2: 151,
    y2: 123,
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg404NotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/404-not-found.df464dbb8ef68adc1fdcf5475a06f930.svg";